import React from 'react'
import { css } from 'styled-components'
import { cssMeasurement } from '../utils/cssUtils'

export type FlexProps = React.HTMLAttributes<HTMLDivElement> & {
  center?: boolean
  gap?: string | number
  flex?: string | number | boolean
  padding?: string | number
  column?: boolean
  direction?: 'row' | 'column'
  align?: 'center' | 'flex-start' | 'flex-end'
  justify?: 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around'
  wrap?: 'wrap' | 'nowrap' | 'wrap-reverse' | true
}

function Flex(props: FlexProps, ref: React.Ref<HTMLDivElement>) {
  const flexDirection = props.direction ?? (props.column ? 'column' : 'row')

  return (
    <div
      ref={ref}
      css={`
        display: flex;
        flex-direction: ${flexDirection};
        gap: ${cssMeasurement(props.gap ?? 'var(--radius-sm, 8px)')};
        flex: ${props.flex === true ? 1 : props.flex};
        padding: ${props.padding ? cssMeasurement(props.padding) : 'auto'};
        ${props.wrap && `flex-wrap: ${props.wrap === true ? 'wrap' : props.wrap};`}
        ${props.justify && `justify-content: ${props.justify};`}
				${props.align && `align-items: ${props.align};`}
				${props.center &&
        css`
          align-items: center;
          justify-content: center;
        `}
      `}
      {...props}
    />
  )
}

export default React.forwardRef(Flex)
